import NewCategory from "../../../../components/@products/categories/NewCategory";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function CategoryNewPage() {

    return (
        <NewCategory 
            routeType={routeTypes.admin}
        />
    )
}